export default __webpack_public_path__ + "static/media/icons8-bar-chart.bfbcd490.svg";